<template>
  <div class="allcollect">
      <el-tabs type="border-card" >
        <el-tab-pane label="我的下载">
            <div class="collect">
                <!-- 内容 -->
                <div class="collect-box" v-for="(item, index) of List" :key="index">
                    <div class="collect-top" @click="toImg(item)">
                        <div class="file-img">
                            <img :src="item.VAttachmentRemotePath" alt />
                        </div>
                        <div class="file-info">
                          <p class="info-VProductName">{{item.VAttachmentName}}</p>
                        </div>
                    </div>

                    <el-button-group class="collect-bottom">
                        <el-button type="primary" size="mini" plain @click="onFollow(item)" style="margin-left: 5px;">删除下载</el-button>
                    </el-button-group>
                </div>
            </div>
            <!-- 分页器 -->
            <!-- <sorter :totalCount="totalCount"></sorter> -->
            <div class="block">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
                    background
                    layout="prev, pager, next"
                    prev-text="< 上一页"
                    next-text="下一页 >"
                    :total="total">
                </el-pagination>
            </div>
        </el-tab-pane>
    </el-tabs>
    <!-- 添加购物车提示 -->
    <el-dialog
        top="3.5rem"
        width="8%"
        :modal="false"
        :visible.sync="centerDialogVisible"
        :show-close="false"
        class="DialogCon">
        <div class="DialogConBox">
            <i class="el-icon-shopping-cart-full"></i>
            <span>{{text}}</span>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import Sorter from   '../../..//ivew/pagination'
import { jump,getUser } from '../../../../untils/auth'
export default {
    name:'download',
    components:{
        Sorter
    },
    data() {
        return {
            dataForm:{
                user:''
            },
            totalCount:100,
            List: [],
            currentPage: 0,
            pageSize: 8,
            centerDialogVisible: false,
            text: '',
            condition: '',
            total: 0
        }
    },
    created () {
        this.onMycollectRes(this.currentPage);
    },
    methods: {
      jump,


/*        handleCurrentChange (val) {
            this.Data = [];
            for (var i = (this.pageSize * (val - 1)); i < (this.pageSize * val); i++) {
                if (this.List[i]) {
                    this.$set(this.List[i], 'follow', '取消收藏')
                    this.Data.push(this.List[i])
                }
            }
        },*/
        // 我的收藏列表
        onMycollectRes (current){
          var data ={
            "createdBy" : JSON.parse(getUser()).principal.VUserId,
            "current": current,
            "size": this.pageSize
          };
            this.axios.post(window.IPConfig.IP + '/tBPrivateDownload/queryPage.do', data).then((response) => {
                    if (response.data.status == 200) {
                        this.List = response.data.obj.records;
                        this.total = response.data.obj.total
                    }else{
                      this.List = [];
                      this.total = 0
                    }
            })
        },
      handleCurrentChange (val) {
        this.onMycollectRes(val)
      },
      onFollow (arr){
          if (getUser()) {
              this.axios.post(window.IPConfig.IP + '/tBPrivateDownload/deleteById.do?id='+arr.PrivateorderId).then(res => {
                  if (res.status == 200) {
                      if (res.data.status == 200) {
                          this.text = res.data.msg;
                          this.onMycollectRes(this.currentPage);
                      }
                  }
              })
          } else {
              this.jump('/login')
          }
      },
      // 详情跳转
      toImg(arr) {
        let routeData = this.$router.resolve({path:'../imageDetails',query:{
            VProductId: arr.VAttachmentId
          }})

        window.open(routeData.href,'_blank')


      },
    }
}
</script>

<style lang="stylus" scoped>
    .collect {
        display flex
        flex-wrap wrap
    }
    .collect-box {
        width 25%
        //padding-left .2rem
    }
    .collect-top {
        cursor pointer
        //background-color #f8f8f8
        width: 2.05rem
        height: 1.8rem
        display flex
        flex-direction column
        align-items center

    }
    .file-img {
      background :#f2f3f4;
      height 1.5rem
      width :2rem;
      padding: .1rem;
      flex-direction column
      align-items center
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .file-img img {
     max-height 100%;
      max-width 100%;
      cursor :pointer
    }
    .file-info {
      width :2rem
      line-height:0.4rem;
      height :0.3rem;
      padding-left .1rem
      padding-right .1rem
      white-space nowrap
      overflow hidden
      text-overflow ellipsis

    }
    // 标题
    .info-VProductName{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .collect-bottom {
        margin-bottom .1rem
        margin-top 0.1rem
        .el-button--small {
            // padding .07rem .26rem
        }
    }
    .DialogCon >>> .el-dialog {
        background: rgba(0, 0, 0, .8);
    }
    .DialogConBox {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .DialogConBox i {
        font-size: 0.5rem;
        color: #fff;
        margin-bottom: 0.1rem;
    }
    .DialogConBox span {
        color: #fff;
    }
    .search-box{
        border 1px solid #228457
        display flex
        flex-flow row nowrap
        align-items center
        margin-bottom: .3rem;
        width: 30%;
    }
    .search-input{
        display flex
        flex-flow row nowrap
        width 100%
        align-items center
    }
    .search-input /deep/ .el-input__inner{
        border none
    }

    .el-button-group .el-button--primary:first-child {
       border-right-color: none !important
      border-right-color: #228457;
      border-radius: 3px;
    }
    .el-button-group .el-button--primary:last-child {
      border-left-color: none !important
      border-left-color: #228457;
      border-radius: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/components/my/mydownload.vue